"use strict";Object.defineProperty(exports, "__esModule", {value: true});var e=(n,t)=>n.length>t?`${n.substring(0,t)}...`:n,r= exports.a =e;exports.a = r;
